module.exports = __webpack_public_path__ + "img/lerue-logo-w.14f6dbf8.png";